








































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import TaskDetailMixins from '@/mixins/taskDetail'
import DetailHeaderBtns from './DetailHeaderBtns.vue'
import Tabs from '@/views/lawsuit/Tabs.vue'
import LawsuitApi from '@/api/lawsuit'
import moment from 'moment'
import {
	DAI_QUE_REN_LAW,
	DAI_TIAO_JIE,
	DAI_ZHONG_SHEN,
	DAI_JIE_DAN,
	YI_WAN_CHENG,
	YI_GUAN_DAN,
	YI_QU_XIAO,
} from '@/web-task/config.ts'

@Component({
	name: 'lawsuitTaskDetail',
	components: {
		PageLayout,
		DetailHeaderBtns,
		Tabs,
	},
})
export default class lawsuitDetail extends Mixins(TaskDetailMixins) {
	private countdownTime: any = ''
	private startTime: any = ''
	private endTime: any = null
	private interval: any = null

	@Watch('order')
	private orderChange() {
		if (
			![DAI_QUE_REN_LAW, DAI_JIE_DAN, DAI_ZHONG_SHEN].includes(
				this.order.orderStatus
			)
		) {
			return
		}
		// 设置倒计时
		if (this.interval) {
			clearInterval(this.interval)
			this.interval = null
		}
		this.endTime = this.order.endTime && new Date(this.order.endTime)
		this.startTime = this.order.serverTime && new Date(this.order.serverTime)
		this.interval = setInterval(() => {
			if (!(this.startTime && this.endTime)) {
				return
			}
			if (this.endTime - this.startTime >= 1000) {
				this.startTime = new Date(this.startTime.getTime() + 1000)
			} else {
				clearInterval(this.interval)
			}
		}, 1000)
	}

	private get countdownText() {
		let text = ''
		switch (this.order.orderStatus) {
			case DAI_QUE_REN_LAW:
				text = '距离任务自动关单时间'
				break
			case DAI_JIE_DAN:
				text = '距离重新选择律师截止时间'
				break
			case DAI_ZHONG_SHEN:
				text = '距离自动审核通过'
				break
			case YI_GUAN_DAN:
				text = '关单时间'
				break
			case YI_QU_XIAO:
				text = '取消时间'
				break
			case YI_WAN_CHENG:
				text = '完成时间'
				break
			default:
				text = ''
		}
		return text
	}

	private get statusTime() {
		let time = ''
		switch (this.order.orderStatus) {
			case YI_GUAN_DAN:
				time = this.order && this.order.closeTime
				break
			case YI_QU_XIAO:
				time = this.order && this.order.cancelTime
				break
			case YI_WAN_CHENG:
				time = this.order && this.order.auditTime
				break
			default:
				time = ''
		}
		return time
	}

	public getDetail() {
		return LawsuitApi.getLawsuitTaskDetail(this.$route.params.orderId).then(
			(data: any) => {
				if (data.code === 200) {
					this.order = {
						...data.data.orderInfo,
						auditLogs: data.data.auditLogs,
						...data.data.cancelOrder,
					}
					this.injured = {
						operationInfo: data.data.operationInfo,
						lawyerInfo: data.data.lawyerInfo,
						mediaInfo: data.data.mediaInfo,
					}
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			}
		)
	}

	public setNavTabs(task: any) {
		this.tabs = {
			index: '1',
			items: [
				{
					key: '1',
					title: '基本信息',
				},
				{
					key: '2',
					title: '应诉方案',
				},
			],
			active: () => {
				return this.tabs.index
			},
			callback: (key: any) => {
				this.tabs.index = key
			},
		}
		switch (this.order.orderStatus) {
			case DAI_QUE_REN_LAW:
				this.tabs.items = [
					{
						key: '0',
						title: '选择律师',
					},
					{
						key: '2',
						title: '应诉方案',
					},
				]
				break
			case YI_WAN_CHENG:
			case DAI_ZHONG_SHEN:
				this.tabs.items.push({
					key: '3',
					title: '结果信息',
				})
				break
		}
		this.tabs.index = this.tabs.items[0].key
	}

	private beforeDestroy() {
		if (this.interval) {
			clearInterval(this.interval)
		}
	}
}
